<template>
    <div>
        <!-- Modal Unidades -->
        <div class="modal fade" id="selecaoUnidadesModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-dialog-scrollable" role="document">
                <div class="modal-content" v-if="item">
                    <div class="modal-header">
                        <h5 class="modal-title">Unidades</h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 d-flex flex-column">
                                <az-input
                                    sizing="sm"
                                    type="button-group"
                                    :optionsList="[
                                        { id: 1, search: 'Apenas' }, 
                                        { id: 0, search: 'Exceto' }, 
                                    ]"
                                    optionsData="id"
                                    v-model="item.fl_unidades_regra" />
                            </div>
                        </div>

                        <div class="row" v-for="(unidade, iux) in item.lista_unidades.filter(und => und.fl_ativo)" :key="iux">
                            <div class="col col-12">
                                <az-input
                                    sizing="sm"
                                    :edicao="false"
                                    v-model="unidade.st_nome">
                                    <template v-slot:button-pre>
                                        <div class="input-group-prepend">
                                            <button class="btn btn-outline-danger" type="button" id="button-addon1" @click="unidade.fl_ativo = false">
                                                <i class="fa fa-minus" aria-hidden="true"></i>
                                            </button>
                                        </div>
                                    </template>
                                </az-input>
                            </div>
                        </div>
                        
                        <az-input
                            icon="fa fa-plus"
                            sizing="sm"
                            placeholder="Selecionar Unidade..."
                            type="select" 
                            optionsMode="aql"
                            optionsDisplay="st_nome"
                            :optionsParm="{ where: { fl_ativo: true } }"
                            service="unidade_operacaos.index"
                            v-model="nova_unidade"
                            @input="adicionar_unidade" />
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Cancelar</button>
                        <button type="button" class="btn btn-success" @click="selecionar()">Selecionar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import $ from 'jquery';
import AzInput from '../../shared/forms/AzInput.vue';

export default {
    data() {
        return { 
            original: null, 
            item: null, 
            unidades: [], 
            nova_unidade: "", 
        }
    },

    components: { 
        AzInput, 
    }, 

    methods: { 
        abrir(item) { 
            this.original = item;
            this.unidades = [];
            this.item = _.cloneDeep(item);

            if ( this.item.js_unidades && this.item.js_unidades.length ) { 
                this.item.js_unidades
            }

            $('#selecaoUnidadesModal').modal('show');
        },

        adicionar_unidade () { 
            if ( !this.nova_unidade )
                return; 

            this.item.lista_unidades.push(this.nova_unidade);
            this.nova_unidade = null;

            this.$nextTick(() => { 
                this.nova_unidade = "";
            });
        },

        selecionar() { 
            this.original.lista_unidades = this.item.lista_unidades.filter(und => und.fl_ativo);
            this.original.fl_unidades_regra = this.item.fl_unidades_regra;
            this.original.js_unidades = this.original.lista_unidades.map(und => und.id_unidade_operacao);

            $('#selecaoUnidadesModal').modal('hide');
        }
    }
}
</script>
